import useBusinessPostApi from './useBusinessPostApi.js';
import { setCustomFieldsSchemaQuery } from './Queries';

const useSaveCustomFieldSchema = type => {
    const { save, isSaving } = useBusinessPostApi(
        `/custom-fields/schema/${type}`,
    );

    function doSave(schema) {
        return save({
            fields: schema,
        }).then(result => {
            setCustomFieldsSchemaQuery(type, result);
        });
    }

    return {
        save: doSave,
        isSaving,
    };
};

export default useSaveCustomFieldSchema;
